import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

export const StyledTitleContainer = styled(Stack)({
  height: 162,
  maxWidth: 375,
  padding: 32,
  textAlign: 'center',
});

export const StyledErrorContainer = styled(Stack)({ height: '100vh', gap: 20 });
